import { Button } from '@mui/material';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import React, { FC, useState } from 'react';

import { formatHotkey, Hotkey } from '../hotkeys';

export type ShortcutCombo = Pick<Hotkey, 'code' | 'alt' | 'ctrl' | 'shift'>;

interface ShortcutRecorderProps {
  value?: ShortcutCombo;
  onChange: (combo: ShortcutCombo) => void;
}

const MODIFIER_CODES = [
  'AltLeft',
  'AltRight',
  'ControlLeft',
  'ControlRight',
  'ShiftLeft',
  'ShiftRight',
  'MetaLeft',
  'MetaRight',
];

const ShortcutRecorder: FC<ShortcutRecorderProps> = ({ value, onChange }) => {
  const [recording, setRecording] = useState(false);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (!recording) return;
    event.preventDefault();
    event.stopPropagation();
    // Wait until a non-modifier key is pressed alongside the modifiers.
    if (MODIFIER_CODES.includes(event.code)) return;
    onChange({
      code: event.code,
      alt: event.altKey,
      ctrl: event.ctrlKey,
      shift: event.shiftKey,
    });
    setRecording(false);
  };

  const label = recording
    ? 'Press keys…'
    : value?.code
    ? formatHotkey(value)
    : 'Set shortcut';

  return (
    <Button
      variant='outlined'
      size='small'
      color={recording ? 'primary' : 'inherit'}
      startIcon={<KeyboardIcon fontSize='small' />}
      onClick={() => setRecording(true)}
      onKeyDown={handleKeyDown}
      onBlur={() => setRecording(false)}
      sx={{ minWidth: 150, textTransform: 'none' }}
    >
      {label}
    </Button>
  );
};

export default ShortcutRecorder;
